// extracted by mini-css-extract-plugin
var _1 = "O1sitMwhOO5UTgsQdNIs";
var _2 = "KdXsu9mBtqeBihYPXf57";
var _3 = "HZnn6ZmubYzZkl2fJhvD";
export { _1 as "customArea", _2 as "pin", _3 as "previewArea" }
